import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { HlmButton } from '@spartan-ng/helm/button';
import { BrnDialogRef, injectBrnDialogContext } from '@spartan-ng/brain/dialog';
import { ThemedIconComponent } from '../../atoms/themed-icon/themed-icon.component';

export interface UploadConfirmFormData {
  projectName: string;
  selectedModel: string;
  modelName: string;
  description: string;
}

@Component({
  selector: 'ocp-upload-confirm-form',
  templateUrl: './upload-confirm-form.component.html',
  styleUrl: './upload-confirm-form.component.scss',
  imports: [HlmButton, TranslatePipe, ThemedIconComponent],
})
export class UploadConfirmFormComponent {
  private readonly dialogRef = inject<BrnDialogRef<boolean>>(BrnDialogRef, { optional: true });

  protected readonly data = injectBrnDialogContext<UploadConfirmFormData>();

  protected onConfirm(): void {
    this.dialogRef?.close(true);
  }

  protected onCancel(): void {
    this.dialogRef?.close(false);
  }
}
